import ImageResizeExample from "../../../../src/content/blog/fighting-with-git-lfs/image-resize-example";
import React from 'react';
export default {
  ImageResizeExample,
  React
};